import logs from "./Logs";
import rest from "./Rest";
import history from "./history";
import UmbracoUtills from "./UmbracoUtills";
import Validators from "./Validators";
import uploadFilesUtil from './UploadFilesUtil';

const exportedObject = {
  logs,
  rest,
  history,
  UmbracoUtills,
  Validators,
  uploadFilesUtil
};
export default exportedObject;
